// extracted by mini-css-extract-plugin
export default {"link-default":"link-default___fEbBJ","link-grey":"link-grey___YDv0C"};